import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitle: {
		id: 'business-calendar.controllers.update-dates.error-title',
		defaultMessage: "We couldn't save the issue",
		description: 'Error message informing the user that updating the issue failed',
	},
	errorMessage: {
		id: 'business-calendar.controllers.update-dates.error-message',
		defaultMessage: 'Check your connection, then give it another try.',
		description: 'Error message when save fails',
	},
	notFoundErrorTitle: {
		id: 'business-calendar.controllers.update-dates.not-found-error-title',
		defaultMessage: 'Issue not found',
		description:
			'Error message title informing the user that the issue is not found as the user attempts to update the issue',
	},
	notFoundErrorMessage: {
		id: 'business-calendar.controllers.update-dates.not-found-error-message',
		defaultMessage: 'Looks like this issue has been removed.',
		description:
			'Error message description informing the user that the issue is removed as the user attempts to update the issue',
	},
});
